import React from 'react'
import { Link } from 'react-router-dom'
import { ListItem } from 'Lib/List'
import { TERMS_OF_USE_HEADER, PRIVACY_POLICY_HEADER } from 'AccountsConstants/language/account'
import { CLEVERTAP_EVENT_NAME, CLEVERTAP_PLATFORM } from 'AccountsConstants/clevertap'
import { navigateToExternalLink, triggerClevertap } from 'AccountsUtils'

const LegalListItem = ({ legalListInfo }) => {
  const { link, label } = legalListInfo
  const routePage = (itemLink, itemLabel) => () => {
    let clevertapData
    if (itemLabel === TERMS_OF_USE_HEADER) {
      clevertapData = {
        'event type': 'terms of use clicked',
        platform: CLEVERTAP_PLATFORM
      }
    } else if (itemLabel === PRIVACY_POLICY_HEADER) {
      clevertapData = {
        'event type': 'privacy policy clicked',
        platform: CLEVERTAP_PLATFORM
      }
    }
    triggerClevertap(CLEVERTAP_EVENT_NAME, clevertapData)
    navigateToExternalLink(itemLink)
  }
  return (
    <ListItem arrow={true} enableRipple={true} onClick={routePage(link, label)}>
      <Link className="flag h-48">
        <div className="flag__flex">
          <h5 className="fs-17 lh-solid apr-10 t-truncate">{label}</h5>
        </div>
      </Link>
    </ListItem>
  )
}

export default LegalListItem
